import DeviceManager from '../utils/device-manager';
import Swiper from 'swiper';

export default function initTestimonials() : void {
    const $testimonialsContainer = document.querySelectorAll<HTMLElement>('.js-testimonials');

    $testimonialsContainer.forEach($container => {
        new Testimonials($container);
    });
}

export class Testimonials {
    $container: HTMLElement;
    $photosContainer: HTMLElement;
    $quotesContainer: HTMLElement;
    photosSwiper: Swiper;
    quotesSwiper: Swiper;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$photosContainer = this.$container.querySelector('.js-testimonial-photos');
        this.$quotesContainer = this.$container.querySelector('.js-testimonial-quotes');

        const photosSwiperParams = {
            autoHeight: true,
            effect: 'fade',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {},
        };
        photosSwiperParams.breakpoints[DeviceManager.devices.lg] = {
            autoHeight: false,
        };
        this.photosSwiper = new Swiper(this.$photosContainer, photosSwiperParams);

        const quotesSwiperParams = {
            autoHeight: true,
            threshold: 10,
            controller: {
                control: this.photosSwiper,
            },
            breakpoints: {},
        };
        quotesSwiperParams.breakpoints[DeviceManager.devices.lg] = {
            autoHeight: false,
        };
        this.quotesSwiper = new Swiper(this.$quotesContainer, quotesSwiperParams);

        this.photosSwiper.controller.control = this.quotesSwiper;
        this.photosSwiper.update();
        this.quotesSwiper.update();
    }
}
